import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import Header from "./components/Header";
import HomePage from "./pages/HomePage";
import ProductListPage from "./pages/ProductListPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import CheckoutFailPage from "./pages/CheckoutFailPage";
import LoginPage from "./pages/LoginPage";
import JoinPage from "./pages/JoinPage";
import ReservationPage from "./pages/ReservationPage";
import GuestReservationPage from "./pages/GuestReservationPage";
import OrdersPage from "./pages/OrdersPage";
import OrderDetailPage from "./pages/OrderDetailPage";
import QrOrderPage from "./pages/QrOrderPage";
import RequireMember from "./components/common/RequireMember";
import "./styles.css";

/**
 * 회원용 온라인 웹서비스(front-web) 라우팅 진입점.
 * 기존에는 state 기반 화면 전환(로그인/예약)만 있었으나, 상품/장바구니/주문/결제 기능이
 * 추가되면서 react-router 기반 라우팅 + 로그인상태 로컬저장(AuthProvider)으로 전환했다.
 * 로그인상태를 로컬저장소에 지속해야 하는 이유: 토스 결제창은 successUrl/failUrl 로
 * 브라우저를 완전히 새로 로드시키므로, 메모리에만 있던 상태(state)는 결제 완료 후 사라진다.
 */
export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/products" element={<ProductListPage />} />
            <Route path="/product/:productId" element={<ProductDetailPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
            <Route path="/checkout/fail" element={<CheckoutFailPage />} />
            {/* 주문내역/주문상세는 로그인한 회원 본인 데이터라 비회원에게는 노출하지 않는다
                (RequireMember - 역할 경계 정리: 비회원이 직접 주소로 들어오면 로그인 화면으로 안내). */}
            <Route path="/orders" element={<RequireMember><OrdersPage /></RequireMember>} />
            <Route path="/orders/:orderGroupId" element={<RequireMember><OrderDetailPage /></RequireMember>} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/join" element={<JoinPage />} />
            <Route path="/reservation" element={<ReservationPage />} />
            <Route path="/reservation/guest" element={<GuestReservationPage />} />
            {/* 고객이 매장 QR코드로 접속하는 화면 - 원래 관리자 사이트(admin-web)에 있었으나
                고객용 화면이라 여기로 이관했다. 경로는 이미 발급/부착된 QR코드가 그대로
                동작하도록 admin-web 시절과 동일하게 유지한다. 이 화면은 자체 헤더(.to-header)를
                쓰므로 Header.jsx 가 이 경로에서는 스스로 렌더링하지 않는다. */}
            <Route path="/order/:qrToken" element={<QrOrderPage />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}
